<template>
  <div class="side-filter">
    <label
      for="select"
      class="select-label"
      :style="{
        color: tonal.white.white,
      }"
    >
      <span>{{ selected?.title }}</span>
      <arrow-icon :width="12" :height="12" :color="tonal.white.white" />
    </label>

    <div class="options-container">
      <select
        :value="selected?.value"
        @focus="onFocus"
        @blur="onBlur"
        @change="handleSelected"
      >
        <option
          v-for="(option, index) in filteredOptions"
          :key="index"
          :value="option.value"
        >
          {{ option.title }}
        </option>
      </select>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, watch, defineProps, defineEmits, nextTick } from 'vue'
  import { tonal } from '@/constants/tonal'
  import { ArrowIcon } from '@/components/Icons'
  import { useRoute } from 'vue-router/composables'
  import { useCategorySub } from '@/common/use/useCategorySub'

  const props = defineProps({
    options: {
      type: Object,
      default: () => {},
    },
    selectedValue: {
      type: String,
      default: '',
    },
  })
  const emit = defineEmits(['change'])
  const route = useRoute()
  const { replaceRouter } = useCategorySub()

  const selected = ref({})
  const showOptions = ref(false)

  const filterKey = computed(() => props.options?.key)
  const filteredOptions = computed(() => props.options?.itemList || [])
  const defaultOption = computed(() => {
    return (
      props.options?.itemList.find(
        (item) => item.value === props.options?._default,
      ) ?? { value: '', title: '' }
    )
  })

  const incorrectValues = () => {
    selected.value = defaultOption
    replaceRouter({
      ...route.query,
      [filterKey.value]: defaultOption.value?.value,
    })
  }

  const handleSelected = async (event) => {
    if (event) {
      emit('change', { key: filterKey.value, value: event.target.value })
    }
  }

  const onFocus = () => {
    showOptions.value = true
  }

  const onBlur = () => {
    showOptions.value = false
  }

  const getSelected = () => {
    nextTick(() => {
      selected.value = props.options?.itemList?.find(
        (item) => item.value === props.selectedValue,
      )
    })
  }

  const init = () => {
    getSelected()

    if (!selected.value) {
      incorrectValues()
    }
  }

  init()

  watch(
    () => props.selectedValue,
    () => {
      getSelected()
    },
  )
</script>

<style scoped lang="scss">
  .side-filter {
    position: relative;
    text-align: end;
    font-size: 0;

    .select-label {
      font-size: 12px;
      line-height: 18px;
      padding: 0;
      display: inline-flex;
      align-items: center;
      gap: 2px;
      cursor: pointer;
    }

    select {
      position: absolute;
      top: 0;
      right: 0;
      opacity: 0;
      cursor: pointer;
    }
  }
</style>
